// © 2024–2026 Jos Jozef Sytze van der Werf — Alle rechten voorbehouden.
import { cn } from '@/lib/utils'
import { StatusPill, moduleStatusKind } from './StatusPill'

interface ModuleShellProps {
  title:        string
  description?: string
  status?:      'NOT_STARTED' | 'IN_PROGRESS' | 'COMPLETE'
  children:     React.ReactNode
  actions?:     React.ReactNode
  className?:   string
}

const STATUS_LABEL: Record<string, string> = {
  NOT_STARTED: 'Niet begonnen',
  IN_PROGRESS: 'Bezig',
  COMPLETE:    'Gereed',
}

export function ModuleShell({
  title,
  description,
  status,
  children,
  actions,
  className,
}: ModuleShellProps) {
  return (
    <div className={cn('flex flex-col gap-6 animate-fade-in', className)}>
      {/* Header */}
      <div className="flex items-start justify-between gap-4">
        <div className="flex-1 min-w-0">
          <div className="flex items-center gap-2.5 flex-wrap">
            <h1 className="text-xl font-semibold text-ink tracking-[-0.01em]">{title}</h1>
            {status && <StatusPill status={moduleStatusKind(status)} label={STATUS_LABEL[status]} size="sm" />}
          </div>
          {description && (
            <p className="text-sm text-ink-3 mt-1.5 leading-relaxed">{description}</p>
          )}

        </div>
        {actions && <div className="flex items-center gap-2">{actions}</div>}
      </div>

      {/* Content */}
      {children}
    </div>
  )
}
